import { forwardRef } from "react";
import { graphql, useFragment } from "react-relay";

import type { DefaultComponentsProvider } from "~/components/content/content-item-render";
import type { homePrimaryContentItemContent$key } from "~/queries/__generated__/homePrimaryContentItemContent.graphql";
import type { CustomQueryParameters } from "~/types/gtm";

import {
  ActionBar,
  Container,
  Content,
  CoverImage,
  Headline,
  Section,
  StyledEntityLink,
  Summary,
} from "./styles";

export type Props = {
  className?: string;
  customQueryParameters?: CustomQueryParameters;
  provider: DefaultComponentsProvider;
  reference: homePrimaryContentItemContent$key;
};

export const ContentItemHomePrimary = forwardRef<HTMLDivElement, Props>(
  ({ className, customQueryParameters, provider, reference: reference_ }, reference) => {
    const content = useFragment(
      graphql`
        fragment homePrimaryContentItemContent on Content {
          ...entityLink
        }
      `,
      reference_,
    );

    return (
      <Container className={className} ref={reference}>
        <Content>
          <Section>{provider.sections()}</Section>
          <StyledEntityLink query={customQueryParameters} reference={content}>
            <Headline>{provider.headline()}</Headline>
          </StyledEntityLink>
          <Summary>{provider.summary()}</Summary>
          <ActionBar>
            {provider.actionBar({
              isBookmarkVisible: false,
            })}
          </ActionBar>
        </Content>
        <CoverImage>
          {provider.coverImage({
            responsiveVariants: {
              desktopUp: "size540x360",
              homeDesktopUp: "size540x360",
              mobileUp: "size320x240",
              tabletUp: "size540x360",
            },
            withCaption: true,
          })}
        </CoverImage>
      </Container>
    );
  },
);

ContentItemHomePrimary.displayName = "ContentItemHomePrimary";
